import axios from '@liepin/cnpm-js-axios-fe';
import qs from 'qs';

const COMP_ID = 4426009;
export const EXCLUDED_JOB_TITLE_CODE = '2634501';
const CONDITION_API =
  'https://api-c.liepin.com/api/com.liepin.searchfront4c.pc-ecomp-homepage-search-condition';

const API_HEADERS = {
  'X-Fscp-Version': '1.1',
  'X-Client-Type': 'web',
  'X-Fscp-Fe-Version': '20211206',
  'X-Fscp-Std-Info': '{"client_id": "31004"}',
  'X-Requested-With': 'XMLHttpRequest',
};

const requestClient = axios.create({
  withCredentials: true,
  timeout: 10000,
});

function createTraceId() {
  return String(Math.random() * 1e10);
}

export function toOptionMap(list = [], excludeCode) {
  return list.reduce((acc, item) => {
    if (excludeCode && String(item.code) === String(excludeCode)) {
      return acc;
    }
    acc[item.code] = item.name;
    return acc;
  }, {});
}

export async function fetchSearchConditions() {
  const response = await requestClient.post(
    CONDITION_API,
    qs.stringify({ compId: COMP_ID }),
    {
      headers: {
        ...API_HEADERS,
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Fscp-Trace-Id': createTraceId(),
      },
    }
  );

  return response.data || response;
}

export function parseSearchQuery() {
  const params = new URLSearchParams(window.location.search);
  return {
    keywords: params.get('keywords') || '',
    dq: params.get('dq') || '',
    jobTitleCode: params.get('deptId') || '',
  };
}

export function buildRecruitSocietyUrl(filters = {}) {
  const { keywords = '', dq = '', jobTitleCode = '' } = filters;
  const params = new URLSearchParams();
  if (keywords) {
    params.set('keywords', keywords);
  }
  if (dq) {
    params.set('dq', dq);
  }
  if (jobTitleCode) {
    params.set('deptId', jobTitleCode);
  }
  const query = params.toString();
  return query ? `recruitSociety.html?${query}` : 'recruitSociety.html';
}

export function hasSearchFilters(filters = {}) {
  return Boolean(filters.dq || filters.jobTitleCode || filters.keywords);
}
